// src/components/users/components/SearchFilters.jsx
import React from 'react';
import { Filter, Search } from 'lucide-react';

const SearchFilters = ({ 
  searchQuery, 
  onSearchChange, 
  roleFilter, 
  onRoleFilterChange, 
  loading 
}) => {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-3 md:space-y-0 md:space-x-4">
        <div className="flex-1">
          <div className="relative">
            <input
              type="text"
              placeholder="Search users by name, email, or ID..."
              className="w-full pl-10 pr-4 py-2 border rounded-md focus:ring-2 focus:ring-uzima-maroon-400"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <Filter className="h-5 w-5 text-gray-400" />
          <select
            className="border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-uzima-maroon-400"
            value={roleFilter}
            onChange={(e) => onRoleFilterChange(e.target.value)}
          >
            <option value="all">All Roles</option>
            <option value="student">Students</option>
            <option value="counselor">Counselors</option>
            <option value="admin">Admins</option>
            <option value="receptionist">Receptionists</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;